import {Button, DataStatus, EmptyStatus} from 'platform/components';
import {VStack, HStack, Heading, Show} from 'platform/foundation';

import {isNotNilOrEmpty, isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {useInterestData} from '../../../../../hooks/useInterestData';
import {OfferedVehicle} from './OfferedVehicle';

interface OfferedVehiclesProps {
  interestId: string;
  hideScheduleButton?: boolean;
}

export function OfferedVehicles(props: OfferedVehiclesProps) {
  const {offeredVehiclesList, isLoading, isError} = useInterestData(props.interestId);

  return (
    <VStack spacing={6}>
      <HStack width="100%" justify="space-between" align="flex-end">
        <Heading size={4}>{i18n.t('entity.interest.labels.offeredVehicles')}</Heading>
        <Show when={!props.hideScheduleButton}>
          <Button
            size="small"
            variant="link"
            leftIcon="action/calendar_today"
            title={i18n.t('entity.interest.selling.scheduleTestDrive')}
            onClick={() => {}}
          />
        </Show>
      </HStack>

      <DataStatus isLoading={isLoading} isError={isError}>
        <VStack spacing={2}>
          <Show when={isNotNilOrEmpty(offeredVehiclesList)}>
            {offeredVehiclesList?.map((vehicle) => (
              <OfferedVehicle
                key={vehicle.id}
                vehicle={vehicle}
                interestId={props.interestId}
                data-testid={`offeredVehicle-[${vehicle.id}]`}
              />
            ))}
          </Show>
          <Show when={isNilOrEmpty(offeredVehiclesList)}>
            <EmptyStatus
              variant="vehicle"
              headline={i18n.t('entity.interest.selling.noVehiclesSelected')}
            />
          </Show>
        </VStack>
      </DataStatus>
    </VStack>
  );
}
